import React from 'react';
import Routes from '../routes';
import {useRouter} from '../../../../@casino/useRouter';
import {ReactComponent as ArrowDown} from '../../../../@casino/img/down-arrow.svg';
import {ReactComponent as RightArrow} from '../../../../@casino/img/right-arrow.svg';
import { useSelector } from 'react-redux';
import { Allow as AllowMap} from '../../../settings/allow';

const Template = () => {
    const [isShowNavigation, setIsShowNavigation] = React.useState(false);
    const router = useRouter();
    const [isOpenSubNavigation, setIsOpenSubNavigation] = React.useState('');
 
    const view = useSelector(state => state.auth.admin);
    const Allow = AllowMap();
    const navigation = [
        {label: 'Информационная панель', url: '/', visible: view?.allow?.includes(Allow.InformationPanel.allow)},
        {label: 'Статистика', url: '/statistics', visible: view?.allow?.includes(Allow.Statistics.allow)},
        {label: 'Рассылка', url: '/mailing/list/', visible: true},
        {
            label: 'Кредиты',
            tag: 'credit',
            visible: view?.allow?.includes(Allow.HistoryReplenishment.allow || Allow.CreditLine.allow),
            children: [
                {label: 'Кредитная линия', url: '/credit/line', visible: view?.allow?.includes(Allow.CreditLine.allow) },
                {label: 'История пополнений', url: '/credit/history', visible: view?.allow?.includes(Allow.HistoryReplenishment.allow)},
            ]
        },
        {label: 'Джекпоты', url: '/jackpot/list', visible: view?.allow?.includes(Allow.Jackpot.allow)},
        {label: 'Платежные системы', url: '/payment/list', visible: view?.allow?.includes(Allow.PaymentSystem.allow)},
        {
            label: 'Выводы', 
            tag: 'withdrawals',
            visible: view?.allow?.includes(Allow.Withdrawals.allow) ,
            children: [
                {label: 'Выводы', url: '/withdrawals/list', visible: view?.allow?.includes(Allow.Withdrawals.allow)},
            ]
        },
        {
            label: 'Пополнения', 
            tag: 'replenishment',
            visible: view?.allow?.includes(Allow.GamerReport.allow || Allow.ReplenishmentReport.allow),
            children: [
                {label: 'Отчет по игрокам и платежным методам', url: '/replenishment/gamer', visible: view?.allow?.includes(Allow.GamerReport.allow)},
                {label: 'Отчет по платежам', url: '/replenishment/payment', visible: view?.allow?.includes(Allow.ReplenishmentReport.allow)},
            ]
        },
        {label: 'Пользователи', url: '/gamer/list', visible: view?.allow?.includes(Allow.Gamer.allow)},
        {
            label: 'Касса', 
            tag: 'cashiers',
            visible: view?.allow?.includes(Allow.CashierReport.allow || Allow.CashierFinance.allow || Allow.CashierGroup.allow),
            children: [
                // {label: 'Кассиры', url: '/cashiers/list'},
                {label: 'Отчет по сменам', url: '/cashiers/shift/list', visible: view?.allow?.includes(Allow.CashierReport.allow) },
                // {label: 'Подтверждение подарков', url: '/cashiers/confirmed/present'},
                {label: 'Финансовые операции', url: '/cashiers/finance', visible: view?.allow?.includes(Allow.CashierFinance.allow)},
                {label: 'Группы', url: '/cashiers/groups', visible: view?.allow?.includes(Allow.CashierGroup.allow)}
            ]
        },
        {label: 'Тех.поддержка', url: '/support/list', visible: view?.allow?.includes(Allow.Support.allow)},
        {
            label: 'Безопасность', 
            tag: 'security',
            visible: view?.allow?.includes(Allow.SecurityAdmin.allow || Allow.SecurityHistorySignin.allow || Allow.SecurityHistoryEvent.allow),
            children: [
                {label: 'Администраторы', url: '/security/admin', visible: view?.allow?.includes(Allow.SecurityAdmin.allow)},
                {label: 'История входов', url: '/security/history', visible: view?.allow?.includes(Allow.SecurityHistorySignin.allow)},
                {label: 'История действий', url: '/security/event', visible: view?.allow?.includes(Allow.SecurityHistoryEvent.allow)}
            ]
        },
    ]


    return (
        <div>
            <div style={{position: 'relative', zIndex: 1, width: 'calc(100% - 30px)', height: 70, display: 'flex', justifyContent: 'space-between', background: 'rgb(25 38 82)', alignItems: 'center', padding: '0 15px'}} >
                <div 
                    onClick={() => {
                        setIsShowNavigation(!isShowNavigation);
                    }}
                    style={{display: 'flex', justifyContent: 'center', flexDirection: 'column', paddingLeft: 20}}>
                    <div style={{width: 40, height: 3, background: '#fff', marginBottom: 8}}></div>
                    <div style={{width: 40, height: 3, background: '#fff', marginBottom: 8}}></div>
                    <div style={{width: 40, height: 3, background: '#fff', marginBottom: 8}}></div>
                </div>
                <div>
                    <span 
                        onClick={() => {
                            localStorage.removeItem('token');
                            window.location.replace(window.location.origin)
                        }}
                    style={{color: '#fff', fontFamily: 'Montserrat, sans-serif'}}>Выйти</span>
                </div>
            </div>
            <div>
                <Routes />
            </div>

            <div style={{position: 'fixed', visibility: isShowNavigation ? 'visible' : 'hidden', opacity: isShowNavigation ? 1 : 0,  transition: 'all .3s linear', top: 0, left: 0, width: '100%', height: '100%', overflow: 'scroll', background: 'rgb(35 52 110)', zIndex: 20}}>
                
                <div style={{display: 'flex', padding: '19px 0 15px 15px', borderBottom: '1px solid #ececec'}}>
                    <div 
                        onClick={() => {
                            setIsShowNavigation(!isShowNavigation);
                        }}
                        style={{display: 'flex', justifyContent: 'center', flexDirection: 'column', paddingLeft: 20}}>
                        <div style={{width: 40, height: 3, background: '#fff', marginBottom: 8}}></div>
                        <div style={{width: 40, height: 3, background: '#fff', marginBottom: 8}}></div>
                        <div style={{width: 40, height: 3, background: '#fff', marginBottom: 8}}></div>
                    </div>
                    <div style={{display: 'flex', justifyContent: 'center', width: 'calc(100% - 100px)'}}>
                        <span style={{color: '#fff', textTransform: 'uppercase', fontSize: 18, fontFamily: 'Montserrat, sans-serif'}}>Меню</span>
                    </div>
                   
                </div>
                

                {
                    navigation?.map((item) => {
                        if (item.visible) {
                            return (
                                <>
                                <div 
                                    onClick={() => {
                                        if (item.url) {
                                            router.history.push(item.url);
                                            setIsShowNavigation(!isShowNavigation);
                                            setIsOpenSubNavigation('')
                                        } else if (item.tag && isOpenSubNavigation === item.tag) {
                                            setIsOpenSubNavigation('');
                                        } else {
                                            setIsOpenSubNavigation(item.tag)
                                        }
                                    }}
                                    style={{position: 'relative', padding: 20, paddingBottom: 20, display: 'flex', justifyContent: 'center', borderBottom: '1px solid rgba(255,255,255,.3)'}}>
                                    <span style={{color: '#fff', fontFamily: 'Montserrat, sans-serif'}}>{item.label}</span>
                                    {
                                        item.tag && isOpenSubNavigation === item.tag &&
                                        <span><ArrowDown style={{position: 'absolute', top: 22, left: 20, width: 15, height: 15, fill: "#fff"}}/></span>
                                    }
                                    {
                                        item.tag && isOpenSubNavigation !== item.tag && 
                                        <span><RightArrow style={{position: 'absolute', top: 22, left: 20, width: 15, height: 15, fill: "#fff"}}/></span>
                                    }
                                </div>
                                {
                                    isOpenSubNavigation === item.tag && item.children && item.children.map((data) => {
                                        if (data.visible) {
                                            return (
                                                <div 
                                                    onClick={() => {
                                                        router.history.push(data.url);
                                                        setIsShowNavigation(!isShowNavigation);
                                                    }}
                                                    style={{padding: 20, display: 'flex', justifyContent: 'center', background: '#141b33', borderBottom: '1px solid rgba(255,255,255,.3)'}}>
                                                    <span style={{color: '#fff', fontFamily: 'Montserrat, sans-serif'}}>{data.label}</span>
                                                </div>
                                            )
                                        }
                                        return <></>
                                        })
                                }
                                </>
                            )
                        }
                        return <></>
                    })
                }
            </div> 
        </div>
    )
}

export default Template;